import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ChatRoom from "./pages/ChatRoom";
import Landing from "./pages/Landing";
import VoiceRoom from "./pages/VoiceRoom";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <Router>
      <Toaster
        position="top-center"
        gutter={8}
        toastOptions={{
          duration: 3000,
        }}
        pauseOnHover={false}
        closeOnClick={false} // 🔥 IMPORTANT
      />
      <div style={{ width: "100%", minHeight: "100vh" }}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<Home />} />
          <Route path="/chat/:roomId" element={<ChatRoom />} />
          <Route path="/voice" element={<VoiceRoom />} />
          <Route path="/voice/:roomId" element={<VoiceRoom />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
